import { template, fetchData } from './utils'

//  Initialize Google Map
const initializeMap = (container) => {
	const $mapContainer = container;
	let lat = $mapContainer.data('lat');
	let lng = $mapContainer.data('lng');
	let zoom = $mapContainer.data('zoom');
	let map;
	let source = $mapContainer.data('source');
	const pinPath = $mapContainer.data('pin');
	const pinPathBlue = 'assets/images/google-marker-blue.png';

	const infoboxMarkup = $('#locations').html();
	const infoboxMarkupBlue = $('#locations-blue').html();

	let selectedInfoWindow;
	let selectedMarker = null;

	let infoContent;


	//  Custom Retina Pin
	const size = new google.maps.Size(40, 49);
	const scaledSize = new google.maps.Size(40, 49);

	const pin = {
		url: pinPath,
		size,
		scaledSize
	}

	// Map Options
	const mapOptions = {
		zoom: zoom,
		center: new google.maps.LatLng(lat, lng),
		disableDefaultUI: true,
		panControl: false
	};

	map = new google.maps.Map($mapContainer[0], mapOptions);

  	fetchData(source).then(response => {
		$.each(response, function(key, data) {
			let marker = new google.maps.Marker({
				position: new google.maps.LatLng(data.lat, data.lng),
				map: map,
				icon: pin
			});

			if ( !$mapContainer.data('infowindow') === false ) {
				infoContent = template(infoboxMarkup, data);

				if (data.type == 'blue') {
					marker.setIcon({
						url: pinPathBlue,
						size,
						scaledSize
					});

					infoContent = template(infoboxMarkupBlue, data);
				}

				const infowindow = new InfoBox({
					content: infoContent,
					maxWidth: 236,
					alignBottom: true,
					pixelOffset:new google.maps.Size(-130, -60)
				});

				marker.addListener('click', function() {
					if (
						selectedInfoWindow != null &&
						selectedInfoWindow.getMap() != null
					) {
						selectedInfoWindow.close();
					} else if (selectedInfoWindow == infowindow) {
						selectedInfoWindow = null;
					}

					selectedInfoWindow = infowindow;
					selectedInfoWindow.open(map, marker);
				});

				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open(map, this);
				});
			}
		});
  	});
}

const setMarkerOptions = (lat, iconSrc) => {
	let markerOptions = {
		position: new google.maps.LatLng(data.lat, data.lng),
		map: map,
		icon: iconSrc
	}
}

export default initializeMap;



// WEBPACK FOOTER //
// ../src/assets/js/googleMap.js